import React from "react";
import {
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

// eslint-disable-next-line arrow-body-style
const TheContextEmpoweringIndia = () => {
	return (
		<>
			{/* members */}
			<Flex
				as="section"
				flexDirection="column"
				overflow="hidden"
				justify="center"
				height={{ xs: "450px", sm: "300px" }}
				minH={{ xs: "450px", sm: "300px" }}
				maxH="450px"
				pos="relative"
			>
				<Img
					pos="absolute"
					objectFit="cover"
					src="/jpg/blogBanner.jpg"
					alt="members-hero"
					height="100%"
					width="100%"
				/>
				<Box
					bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
					pos="absolute"
					height="100%"
					width="100%"
					opacity="0.7"
				/>
				<Container
					display="flex"
					as="section"
					maxW="container.xl"
					position="relative"
					zIndex="1"
					flexDirection="column"
				>
					<Flex
						alignItems={{ xs: "flex-start", md: "flex-start" }}
						justifyContent="center"
						columnGap="24px"
						justifyItems="center"
						width="100%"
						display="flex"
						as="section"
						rowGap="30px"
						flexDir={{
							xs: "column",
							md: "row",
						}}
					>
						<Flex flexDir="column" rowGap="16px">
							<Heading
								color="white"
								fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
								fontWeight="800"
								lineHeight={{ xs: "35px", lg: "83px" }}
							>
								#TheContext
							</Heading>
						</Flex>
						<Box
							w="1.5px"
							h={{ xs: "100%" }}
							bgColor="white"
							display={{ xs: "none", md: "block" }}
						/>
						<Box
							w={{ xs: "70%", sm: "60%" }}
							h="1.5px"
							bgColor="white"
							display={{ xs: "block", md: "none" }}
						/>
						{/*  */}
						<Heading
							as="h1"
							mb={{ xs: "10px", md: "20px" }}
							variant="reportCardTitle"
							fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "38px" }}
							color="white"
							lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "62px" }}
						>
							Empowering India&apos;s Climate-tech Leadership: Utilizing
							Innovation Hubs to Foster Scalable-cum-Sustainable Growth
						</Heading>
					</Flex>
				</Container>
			</Flex>
			<Container
				as="section"
				maxW="container.xl"
				pb="80px"
				pt="40px"
				minH="420px"
				display={{ xs: "flex", md: "inherit" }}
				flexDirection="column"
			>
				<Box
					float={{ xs: "right", md: "left" }}
					alignSelf={{ xs: "center", md: "flex-start" }}
					mx={{ xs: "0px", md: "0px" }}
					mr={{ xs: "0px", md: "40px", lg: "60px", xl: "40px" }}
					mb="20px"
				>
					<Flex
						flexDir={{
							xs: "column",
							md: "row",
						}}
						gap="20px"
						alignItems={{
							xs: "center",
							md: "unset",
						}}
					>
						<Img
							src="https://static.levocdn.com/WGLBUT82/SandiipBhammer-01T4tMvoJ6N9.jpg"
							alt="Sandiip Bhammer"
							width="250px"
							height="250px"
							objectFit="cover"
							borderRadius="50%"
						/>
						<Flex direction="column">
							<Heading
								as="h1"
								fontWeight="800"
								pt="20px"
								variant="reportCardTitle"
								fontSize={{ xs: "16px", md: "18px", lg: "20px" }}
								textAlign={{
									xs: "center",
									md: "left",
								}}
							>
								Sandiip Bhammer
								<Link
									href="https://www.linkedin.com/in/sandiip-bhammer-94953614/"
									target="_blank"
									display={{ xs: "inline-block", md: "none" }}
									pl="10px"
								>
									<IconButton
										aria-label="linkedin"
										icon={<FaLinkedin size="28px" color="#067acc" />}
										variant="unstyled"
										cursor="pointer"
									/>
								</Link>
							</Heading>
							<Text
								color="text.mediumBlack"
								maxW={{
									xs: "100%",
									md: "120px",
								}}
								w="100%"
								fontSize="16px"
								lineHeight="22px"
								fontStyle="italic"
								textAlign={{
									xs: "center",
									md: "left",
								}}
							>
								Founder & Managing Partner, Green Frontier Capital; Board
								Member, The Newlab Group LLC
							</Text>

							<Link
								href="https://www.linkedin.com/in/sandiip-bhammer-94953614/"
								target="_blank"
								display={{
									xs: "none",
									md: "block",
								}}
							>
								<IconButton
									aria-label="linkedin"
									icon={<FaLinkedin size="28px" color="#067acc" />}
									variant="unstyled"
									cursor="pointer"
								/>
							</Link>
						</Flex>
					</Flex>
				</Box>
				<Box>
					<Box mt="16px" mb="20px">
						<Text variant="blogAnswer">
							India’s pressing climate challenges align with its vast potential
							for innovation, making it an ideal candidate for climate-tech hubs
							to drive a sustainable future. This paper explores how adopting
							Newlab’s successful innovation hub model could help India meet its
							climate-tech needs. By establishing climate focused hubs that
							leverage 3 key pillars - infrastructure, commercialization
							projects, and capital - as used by Newlab to achieve similar
							objectives elsewhere, India can also tackle critical environmental
							issues, foster economic growth, and position itself as a regional,
							if not global, leader in climate-tech innovation.
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							The alternative capital industry in India has experienced a
							remarkable transformation over the past few quarters, with private
							capital assets under management (AUM) more than tripling to $124.3
							billion by the end of 2023. Recognizing this growth, #AltCap101 is
							designed to equip experienced fund managers with the tools and
							knowledge they need to navigate the rapidly evolving landscape.
							This full-day program focuses on critical areas like governance
							best practices, regulatory frameworks, and emerging trends,
							offering attendees a comprehensive understanding of the
							industry&apos;s future direction.
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							Overview
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							As the third-largest emitter of greenhouse gases, India faces
							significant challenges across energy, agriculture, transportation,
							and industry sectors. With an annual output of over 4 billion
							metric tons of CO₂, the country’s climate priorities are national
							and global. India’s young, skilled workforce and increasing
							commitment to sustainability make it well-positioned to foster
							climate-tech innovation. The success of Newlab, an
							interdisciplinary innovation hub in New York’s Brooklyn Navy Yard,
							offers valuable insights for India. Newlab’s approach, anchored
							around{" "}
							<strong>
								three core pillars, namely Infrastructure, Commercialization
								Projects, and Capital,
							</strong>
							addresses key commercialization barriers that startups typically
							face. By adopting this model, India can create regional hubs to
							advance climate-tech solutions and establish itself as a leader in
							sustainable innovation.
						</Text>
					</Box>
					{/* 2 */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							The Newlab Model - A Blueprint for Innovation Hubs:
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							Established in 2016, Newlab is an 84,000-square-foot facility in
							Brooklyn (New York City) designed to support frontier technology
							enterprises and foster interdisciplinary collaboration. It
							operates on three key pillars - Infrastructure, Commercialization
							Projects, and Capital - that together address the unique needs of
							hardware-focused, science-based, and engineering-intensive
							startups, providing a scalable path to market. This model has
							proven effective in accelerating innovation and commercializing
							technologies that tackle large-scale challenges, particularly in
							sectors such as energy, materials, and mobility.
						</Text>
					</Box>
					{/* 3 */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							1. Infrastructure
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							Newlab’s physical infrastructure is purpose-built for critical
							technology startups. By providing shared labs, technical
							infrastructure, and collaborative workspaces, Newlab significantly
							reduces development costs and timelines for climate-tech startups.
							Importantly, each Newlab hub has access to first-of-a-kind
							industrial pilot sites, enabling startups to test and deploy
							technologies in real-world settings. This infrastructure is
							essential for hardware and engineering-intensive technologies
							requiring extensive prototyping and validation stages. In India,
							similar hubs could be developed with specialized resources, such
							as dedicated labs for renewable energy, waste management, or water
							conservation. Partnerships with universities and government
							agencies could make these facilities more accessible, allowing
							startups to iterate faster and bring their solutions to market
							more efficiently.
						</Text>
					</Box>
					{/* 3  */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							2. Commercialization Projects
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							Newlab’s commercialization projects facilitate collaborations
							between startups and end-users, be they in industry or government,
							through projects that de-risk the techno-economic aspects of these
							technologies. By accelerating commercial development timelines,
							these partnerships allow startups to demonstrate the feasibility
							and scalability of their solutions within months instead of years.
							For instance, Newlab’s Mobility Studio in Detroit, a partnership
							with Ford, has led to significant advancements in electric vehicle
							technology and mobility solutions. In India, similar studio models
							could enable rapid prototyping of technologies aimed at pressing
							challenges such as water scarcity, waste management, and renewable
							energy. By fostering collaboration between startups and industry
							leaders, India could leverage commercialization projects to ensure
							that climate-tech solutions are economically viable and scalable.
						</Text>
					</Box>
					{/* 4 */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							3. Capital
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							Access to high-risk capital is essential for scaling high-impact
							climate-tech solutions. Newlab addresses this need by providing a
							blend of direct investments, access to a global investor network,
							and non-dilutive funding from strategic partners. This capital
							focus enables Newlab to support startups with validated paths to
							scale, making it easier for them to navigate early challenges
							without compromising their equity or diluting ownership. In India,
							an analogous capital model could attract domestic and
							international investors eager to back climate-tech solutions. By
							aligning investors with high-potential startups, India could tap
							into climate-focused venture funds, securing the resources needed
							to scale sustainable solutions that address regional and global
							environmental challenges.
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							4. Adapting the Newlab Model for India’s Climate-tech Needs
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							India’s environmental challenges are both diverse and
							region-specific, meaning that a one-size fits-all approach is
							unlikely to succeed. Regional hubs, each focusing on local climate
							issues, could address these unique needs while scaling solutions
							for broader applications.
						</Text>
					</Box>
					<Box>
						<UnorderedList>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Localized Innovation Studios:
									</span>
									<br />
									Newlab’s innovation studios, where startups collaborate with
									industry and government to address specific climate
									challenges, are an adaptable component that could be
									especially impactful in India. Establishing localized studios
									in various regions could help address targeted environmental
									needs—such as water conservation in Bengaluru, air pollution
									mitigation in Delhi, or waste management in Mumbai. Each
									studio could be developed in partnership with local
									governments, NGOs, and private-sector players, ensuring that
									solutions are technically sound and aligned with regional
									regulations and market needs. This structure would also help
									scale solutions by tailoring them to specific local
									conditions, making them more likely to succeed and be
									replicated in similar environments.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Public-Private Partnerships:
									</span>
									<br />
									Newlab’s close collaboration with New York City agencies
									positions it as a partner in navigating regulatory landscapes
									and aligning innovation with government goals. In India,
									public-private partnerships could enable innovation hubs to
									align with central and regional government priorities. These
									partnerships would provide startups with essential support to
									navigate regulatory pathways, while also fostering an
									environment where startups can receive guidance and policy
									insights from key government stakeholders. By involving the
									government in developing climate solutions, India could create
									an ecosystem where public policy actively supports
									climate-tech scaling and market entry.
								</Text>
							</ListItem>
							<ListItem>
								<Text as="span" variant="blogAnswer" py="16px">
									<span style={{ fontWeight: "bold" }}>
										Global Success Stories as Proof of Concept:
									</span>
									<br />
									Newlab’s collaborations with Saudi Arabia and Uruguay
									illustrate how its model can adapt to different economic and
									regulatory environments, fostering climate-tech innovation
									globally. Saudi Arabia’s Vision 2030 partnership with Newlab
									seeks to drive technological innovation in the energy and
									mobility sectors, promoting sustainability and economic
									diversification. In Uruguay, Newlab’s collaboration with the
									National Agency for Research and Innovation has led to the
									Ethical AI Studio, fostering AI-driven climate solutions
									across Latin America. By examining these international success
									stories, India can understand how to structure public-private
									partnerships, create effective innovation hubs, and implement
									Newlab inspired frameworks that align with the nation’s
									specific environmental and economic priorities.
								</Text>
							</ListItem>
						</UnorderedList>
					</Box>

					{/*  */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							5. Economic Benefits: Job Creation and Investment Potential:
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							The economic advantages of climate-tech hubs go beyond innovation.
							They generate jobs and attract investment. A Newlab-inspired model
							could catalyze employment growth in clean energy, sustainable
							agriculture, and green infrastructure sectors, creating roles that
							align with sustainable development goals. India’s large, youthful
							workforce is ideally positioned to benefit from these
							opportunities, and climate accelerators could play a significant
							role in bridging the gap between employment and environmental
							goals.
							<br />
							Furthermore, Newlab’s established network of investors and venture
							capitalists has proven effective in securing funding for impactful
							startups. A climate-tech hub in India could similarly attract
							domestic and international capital, with investors drawn to the
							dual benefits of environmental resilience and economic growth. By
							positioning India as a leader in climate tech, such hubs could
							draw substantial funding from global climate-focused venture
							capital, making India a prime destination for climate tech
							investments in the Global South.
						</Text>
					</Box>
					{/*  */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							6. Scaling the Model Across India’s Diverse Regions:
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							India’s climate-tech innovation strategy would be most effective
							if scaled through a network of regional hubs in major cities like
							Bengaluru, Delhi, Mumbai, and Pune. Each hub could focus on sector
							specific challenges relevant to its region, such as renewable
							energy in solar-rich states, water conservation in drought-prone
							areas, and air quality improvement in high-pollution urban
							centers. This distributed model would ensure that local needs are
							addressed and foster inter-hub collaboration, allowing for
							solutions developed in one region to be adapted and scaled across
							the country.
						</Text>
					</Box>
					{/*  */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							7. Ensuring Financial Viability and Long-Term Sustainability:
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							To ensure longevity, climate-tech hubs in India could adopt
							Newlab’s revenue diversification model. Newlab sustains itself
							through a mix of rental income, membership fees, consultancy
							services, and venture financing, reducing dependence on external
							funding. Indian climate-tech hubs could similarly charge fees for
							participation in innovation studios, engage in consultancy
							projects, and establish Special Purpose Vehicles to pool
							investments for promising startups. This diversified approach
							would enable hubs to maintain financial health while reinvesting
							in resources that support long-term innovation and growth.
						</Text>
					</Box>
					{/* Conclusion */}
					<Box my="16px">
						<Text variant="blogAnswer" fontWeight="800">
							Conclusion:
						</Text>
					</Box>
					<Box my="16px">
						<Text variant="blogAnswer">
							India stands at a pivotal point in its journey toward climate
							resilience and sustainable growth. By adopting a model inspired by
							Newlab, the country can create a robust climate-tech ecosystem
							that not only addresses its own environmental needs but could also
							position it as a regional, if not a global leader, in sustainable
							innovation. Climate-tech hubs that integrate Newlab’s core pillars
							- infrastructure, commercialization projects, and capital - could
							catalyze India’s shift toward a green economy, aligning with
							national climate goals, fostering economic growth, and generating
							green jobs for India’s vast workforce. Through these efforts,
							India could inspire similar initiatives across the developing
							world, demonstrating that climate challenges can be transformed
							into opportunities for sustainable development and global
							leadership in climate-tech. <br /> <br />
							By building a network of regionally specialized hubs, supported by
							interdisciplinary collaboration, public-private partnerships, and
							a robust investor ecosystem, India can set the stage for a
							climate-tech revolution that accelerates its journey toward a
							sustainable, resilient future.
						</Text>
					</Box>

					<Box my="16px">
						<Text variant="blogAnswer">
							For more information and to register, visit
							<Link
								href="https://www.ivca.in/altcap-101"
								target="_blank"
								fontWeight="700"
								ml="4px"
								style={{ color: "blue", textDecoration: "underline" }}
							>
								https://www.ivca.in/altcap-101
							</Link>
						</Text>
					</Box>
				</Box>

				<Box width="100%" height="2px" bgColor="primary.200" />
				<Text
					variant="blogAnswer"
					lineHeight="30px"
					pt="18px"
					fontStyle="italic"
					p="12px 12px 0px"
					fontWeight="500"
				>
					<Text as="span" fontWeight="700" fontStyle="normal">
						#TheContext by IVCA
					</Text>{" "}
					– features opinion makers from the alternate investing industry with
					strong focus on India as an investment destination. Watch this space
					for new announcements in the sector, viewpoints on investment themes,
					emerging trends, economic reports, analysis and latest industry
					insights.
				</Text>
				<Heading
					variant="blogQuestion"
					lineHeight="30px"
					pt="16px"
					fontStyle="italic"
					p="12px 12px 0px"
				>
					Content in this section is curated by team IVCA. To share feedback,
					connect with&nbsp;
					{/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
					<Link
						href="mailto:paromita.sinha@ivca.in"
						target="_blank"
						style={{ color: "blue", textDecoration: "underline" }}
					>
						paromita.sinha@ivca.in
					</Link>
				</Heading>
			</Container>
		</>
	);
};

export default TheContextEmpoweringIndia;
